import TomSelect from 'tom-select'

document.addEventListener('DOMContentLoaded', () => {
    const tomSelectElements = document.querySelectorAll('[data-tom-select]')

    tomSelectElements.forEach((element) => {
        const isMultiple = element.hasAttribute('multiple')

        const ts = new TomSelect(element, {
            create: false,
            allowEmptyOption: true,
            hidePlaceholder: true,
            hideSelected: false,
            copyClassesToDropdown: false,
            maxOptions: false,
            plugins: isMultiple
                ? {
                    remove_button: {
                        title: 'Odstranit',
                    },
                }
                : {},
            render: {
                no_results(data, escape) {
                    return `<div class="no-results p-2">Žádné výsledky pro "${escape(data.input)}"</div>`
                },
            },
        })

        const origOnOptionSelect = ts.onOptionSelect.bind(ts)
        ts.onOptionSelect = function(evt, option) {
            const value = option?.dataset?.value
            if (!value) return origOnOptionSelect(evt, option)

            const current = isMultiple ? ts.getValue() : ts.getValue() ? [ts.getValue()] : []

            if (current.includes(value)) {
                if (isMultiple) {
                    ts.removeItem(value)
                    ts.refreshOptions(false)
                } else {
                    ts.clear()
                    ts.close()
                }
                return
            }

            origOnOptionSelect(evt, option)
        }
    })
})
